import ResendPhoneTokenError from './ResendPhoneTokenError';
class PhoneNumberIsAlreadyVerified extends ResendPhoneTokenError {
    constructor(options) {
        super('Phone number is already saved', options);
    }
}
export default PhoneNumberIsAlreadyVerified;
